import { Button, Divider, TextField, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import * as React from "react";

import { Form, KeyStringValue, Query } from "../interfaces";

const PREFIX = "MultiAddCerts";

const classes = {
  manualAddCertButton: `${PREFIX}-manualAddCertButton`,
};

const Root = styled("form")(({ theme }) => ({
  [`& .${classes.manualAddCertButton}`]: {
    "&.MuiButton-contained.MuiButton-colorPrimary": {
      "display": "flex",
      "margin": "1.5rem auto .5rem auto",
      "height": 40,
      "fontSize": "1rem",
      "width": 160,
      "&.Mui-focusVisible, &:hover": {
        backgroundColor: "#ffffff",
        color: theme.palette.primary.main,
      },
      "&:active": {
        backgroundColor: "#7B97BC",
        borderColor: theme.palette.primary.main,
        color: "#fff",
      },
    },
  },
}));

interface Props {
  updateCerts: (certs: string[]) => void;
  currentValue?: string;
  disabled?: boolean;
  fieldName?: string;
  label?: string;
  form?: Form;
  setForm?: React.Dispatch<any>;
  appState?: Query;
  submitCerts?: (certs: any) => void;
}
export default function MultiAddCerts({
  updateCerts,
  currentValue,
  disabled,
  fieldName,
  label,
  form,
  setForm,
  appState,
  submitCerts,
}: Props) {
  const [certs, setCerts] = React.useState<string[]>([]);
  const regEx = "^[0-9, ]*$";
  const handleChange = (event: any) => {
    if (RegExp(regEx).test(event.target.value)) {
      setCerts(event.target.value.split(","));
    }
  };
  const handleFormUpdate = (event: any) => {
    let newValue = event.target.value.split(",");
    if (RegExp(regEx).test(newValue)) {
      setCerts(newValue);
      setForm &&
        setForm((prevState: KeyStringValue) => ({
          ...prevState,
          multiCert: newValue.map((cert: string) => cert.replace(/ /g, "")),
        }));
    }
  };
  React.useEffect(() => {
    if (appState?.filters.multiCert) {
      setCerts(appState.filters.multiCert.join(", "));
    }
  }, [appState]);

  return form ? (
    <>
      <TextField
        id="outlined-multiline-flexible"
        label="Enter Certs"
        multiline
        minRows={2}
        fullWidth
        value={certs}
        variant="outlined"
        onKeyDown={(e) => {
          if (e.key === "Enter" && submitCerts && Array.isArray(certs)) {
            submitCerts(certs);
          }
        }}
        onChange={(e) => handleFormUpdate(e)}
        slotProps={{
          inputLabel: {
            style: { color: "grey" },
          },
        }}
      />
      <Typography variant="body1" color="primary.main">
        Enter Certs singly or in multiples separated with commas (e.g., 12345,
        765, 345, etc.)
      </Typography>
    </>
  ) : (
    <Root
      style={{ marginBottom: "1.5rem" }}
      onSubmit={(e: any) => {
        e.preventDefault();
        updateCerts(certs.map((cert: string) => cert.replace(/ /g, "")));
        setCerts([]);
      }}
    >
      <TextField
        id="outlined-multiline-flexible"
        label="Enter Certs"
        multiline
        minRows={2}
        fullWidth
        value={certs}
        variant="outlined"
        onChange={(e) => handleChange(e)}
      />
      <Typography variant="body1" color="primary.main">
        Enter Certs singly or in multiples separated with commas (e.g., 12345,
        765, 345, etc.)
      </Typography>

      <Divider variant="fullWidth" />
      <Button
        variant="contained"
        color="primary"
        disableElevation
        id="multiAddCertSubmit"
        className={classes.manualAddCertButton}
        type="submit"
      >
        Add to List
      </Button>
    </Root>
  );
}
